export const DEFAULT_POSITION_MAIN = [
  [
    { x: 639, y: 394 },
    { x: 1052, y: 410 },
  ],
  [
    { x: 639, y: 176 },
    { x: 1052, y: 193 },
  ],
  [
    { x: 639, y: 616 },
    { x: 1052, y: 632 },
  ],
  [
    { x: 639, y: -22 },
    { x: 1052, y: -5 },
  ],
  [
    { x: 639, y: 833 },
    { x: 1052, y: 849 },
  ],
];